<template>
    <div class="payaccount-wrap">
        <template v-if="autoReloadData.quickAccountTransferBillkey && autoReloadData.autoReloadPayToolCode === 'ACCOUNT_TRANSFER'">
          <div class="account-info">
              <div class="info-wrap">
                  <span>{{ autoReloadData.bankName }}</span>
                  <span>{{ autoReloadData.bankAccountNumber }}</span>
              </div>
              <button type="button" class="btn-change" @click="setAccountTransfer()">계좌 변경</button>
          </div>
        </template>
        <template v-else>
            <div class="no-data" @click="setAccountTransfer()">
                <img src="@/assets/images/ico-plus.svg" alt="계좌 추가하기">
                <span>계좌 추가하기</span>
            </div>
        </template>
    </div>
</template>

<script>
    let tossPayments = ''           // 브랜드페이

    export default {
      name: 'PaymentAccount',
      components: {

      },
      props: ['autoReloadData', 'autoReloadCardInfo'],
      data() {
        return {
          clientKey: process.env.VUE_APP_TOSS_QUICK_CLIENT_KEY, // 클라이언트 키
          customerKey: this.$store.state.mberInfo.mberNo, // 'C21743839' 내 상점에서 고객을 구분하기 위해 발급한 고객의 고유 ID
        }
      },
      mounted() {
        tossPayments = TossPayments(this.clientKey);
      },
      methods: {

        /**
         * 퀵계좌이체 등록 페이지 진입
         */
        setAccountTransfer() {

          // 퀵계좌이체 등록 화면에서 돌아오면 히스토리 조작을 위해 사용
          sessionStorage.setItem('RegisterQuickAccountTransferHistory', 'true');

          // 퀵계좌이체 등록 화면에서 돌아오면 자동충전 데이터 세팅을 위해 사용
          this.$store.commit("setAutoReloadCard", {autoReloadData: this.autoReloadData, autoReloadCardInfo : this.autoReloadCardInfo});

          // 퀵계좌이체 등록 호출(토스페이먼츠)
          tossPayments
              .requestBillingAuth("계좌이체", {
                // 결제수단 파라미터
                // 결제 정보 파라미터
                customerKey: this.customerKey, // 구매자 ID로 상점에서 만들어야 합니다. 빌링키와 매핑됩니다. 자세한 파라미터 설명은 파라미터 설명을 참고하세요: https://docs.tosspayments.com/sdk/payment-js#결제-정보-5
                successUrl: `${process.env.VUE_APP_EMARTICON_SITE_DOMAIN}/emarticon/card/autoCharging`, // 계좌 등록에 성공하면 이동하는 페이지(직접 만들어주세요)
                failUrl: `${process.env.VUE_APP_EMARTICON_SITE_DOMAIN}/emarticon/card/autoCharging`, // 계좌 등록에 실패하면 이동하는 페이지
              })
              .catch(function (error) {
                if (error.code === "USER_CANCEL") {
                  // 구매자가 결제창을 닫았을 때 에러 처리
                }
              });
        }
      }
    };
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/common/paymentAccount.scss';
</style>